/**
 * REDUX STORE
 * Central state management configuration
 */

import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import semanticReducer from './slices/semanticSlice';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import explanationReducer from './slices/explanationSlice';
import monitoringReducer from './slices/monitoringSlice';

export const store = configureStore({
  reducer: {
    semantic: semanticReducer,
    auth: authReducer,
    ui: uiReducer,
    explanation: explanationReducer,
    monitoring: monitoringReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['semantic/updateState', 'monitoring/updateMetrics'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.timestamp', 'payload.callback'],
        // Ignore these paths in the state
        ignoredPaths: ['semantic.lastUpdate', 'monitoring.lastHeartbeat'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
